<template>
  <div class="app-container">
    <div class="screeBox">
      <!-- <el-select
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        v-if="userInfo.park_id == 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-input
        class="screenInput"
        v-model="screen.username"
        placeholder="请输入用户登录名"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入手机号"
        maxlength="11"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        v-if="roles.includes('/admin_user/add') && userInfo.type == 0"
        >添加用户</el-button
      >
      <el-button
        size="medium"
        type="danger"
        @click="delUser()"
        v-if="roles.includes('/admin_user/batch_del')"
        >删除用户</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55" :selectable="selectable">
      </el-table-column>
      <el-table-column align="center" label="序号" width="50">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="用户登录名">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
      <el-table-column label="头像" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.picture"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.picture"
          />
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.park">
            {{ scope.row.park.name }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="企业名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.company">
            {{ scope.row.company.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="角色" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.system_role">{{
            scope.row.system_role.title
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="账号类型" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1
              ? "园区"
              : scope.row.type == 2
              ? "企业"
              : scope.row.type == 3
              ? "集团"
              : ""
          }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="info"
            @click="openPassEdit(scope.row)"
            v-if="roles.includes('/admin_user/edit_password')"
            >修改密码</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/admin_user/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/admin_user/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="
              roles.includes('/admin_user/del') &&
              userInfo.id != scope.row.id &&
              scope.row.type != 0
            "
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="600px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户登录名" prop="username">
          <el-input
            v-model="ruleForm.username"
            :disabled="cztype == 'see'"
            placeholder="请输入账号名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password" v-if="cztype == 'add'">
          <el-input
            v-model="ruleForm.password"
            :disabled="cztype == 'see'"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword" v-if="cztype == 'add'">
          <el-input
            v-model="ruleForm.repassword"
            :disabled="cztype == 'see'"
            show-password
            placeholder="请输入确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            maxlength="11"
            v-model="ruleForm.phone"
            :disabled="cztype == 'see'"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="帐号类型" prop="type">
          <el-radio-group
            v-model="ruleForm.type"
            :disabled="cztype == 'see'"
            @change="typeRadio"
          >
            <el-radio
              :label="1"
              :disabled="userInfo.type == 1 || userInfo.type == 2"
              >园区</el-radio
            >
            <el-radio
              :label="2"
              >企业</el-radio
            >
            <el-radio :label="3" :disabled="userInfo.type != 0">集团</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="园区" prop="park_id" v-if="ruleForm.type != 3">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="企业"
          :rules="{
            required: true,
            message: '企业不能为空',
            trigger: 'blur',
          }"
        >
          <el-select
            filterable
            v-model="ruleForm.company_id"
            placeholder="请选择企业"
            :disabled="cztype == 'see'"
            @change="companyChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="角色" prop="system_role_id">
          <el-cascader
            placeholder="请选择角色"
            :disabled="cztype == 'see'"
            v-model="ruleForm.system_role_id"
            :options="roleList"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              label: 'title',
              value: 'id',
              children: 'nodes',
            }"
            clearable
          ></el-cascader>
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="头像" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="{ token: token }"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
            list-type="picture-card"
          >
            <img
              v-if="ruleForm.picture"
              :src="imageUrl + ruleForm.picture"
              class="avatar-uploader"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="头像" prop="icon">
          <el-upload
          :limit="1"
            :action="ossUpload"
            name="file[]"
            :data="{ type: 'image' }"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="ruleForm.picture ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="密码修改" :visible.sync="passDialog" width="30%" center>
      <el-input
        v-model="editPassword.password"
        placeholder="请输入登录密码"
        style="margin-bottom: 10px"
      ></el-input>
      <el-input
        v-model="editPassword.repassword"
        placeholder="请输入确认密码"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passDialog = false">取 消</el-button>
        <el-button type="primary" @click="PassEdit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  userList,
  addUser,
  editUser,
  delUser,
  userInfo,
  delImage,
  openPark,
  openRole,
  openCompany,
} from "@/api/index";
import { editPassword } from "@/api/user";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss",'mainParkId']),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      editPassword: {
        password: "",
        repassword: "",
        id: "",
      },
      passDialog: false,
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加用户",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        username: "",
        phone: "",
        company_id: "",
      },
      ruleForm: {
        username: "",
        password: "",
        repassword: "",
        park_id: "",
        phone: "",
        status: 1,
        system_role_id: "",
        type: 1,
        company_id: "",
        picture: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账户", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
        ],
        // park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        // system_role_id: [
        //   { required: true, message: "请选择角色", trigger: "change" },
        // ],
        // type: [
        //   { required: true, message: "请选择账户类型", trigger: "change" },
        // ],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      roleList: [],
      companyList: [],
      park_id: "",
      fileList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.getCompany(this.userInfo.park_id);
      this.getRole(this.userInfo.park_id);
    } else {
      this.getCompany();
      this.getRole()
      this.screen.park_id = "";
    }
    if (this.userInfo.company_id !== 0) {
      this.screen.company_id = this.userInfo.company_id;
    } else {
      this.screen.company_id = "";
    }
    this.fetchData();
    // this.getpark();
  },
  methods: {
    //删除方法获取到的file是被删除的file
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.picture = "";
    },
    // 修改密码
    openPassEdit(val) {
      this.editPassword.id = val.id;
      this.passDialog = true;
    },
    PassEdit() {
      editPassword(this.editPassword).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.passDialog = false;
        }
      });
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        username: "",
        phone: "",
        company_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      if (this.userInfo.company_id !== 0) {
        this.screen.company_id = this.userInfo.company_id;
      } else {
        this.screen.company_id = "";
      }
      this.fetchData();
    },
    typeRadio(e) {
      if (e == 3) {
        this.getRole();
      } else {
        this.ruleForm.park_id = "";
        this.roleList = [];
      }
    },

    selectable(row, index) {
      if (row.id != this.userInfo.id) {
        return true;
      }
    },
    parkChange(e) {
      this.getRole(e);
    },
    companyChange(e) {
      this.getRole(this.ruleForm.park_id);
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        // if (this.ruleForm.picture) {
        //   this.delImg(this.ruleForm.picture);
        // }
        // this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.picture = res.data.url[0];
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ruleForm.system_role_id =
            that.ruleForm.system_role_id[
              that.ruleForm.system_role_id.length - 1
            ];

          this.$confirm("确认提交？")
            .then((_) => {
              editUser(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  // if (this.oldImg && this.oldImg != that.ruleForm.picture) {
                  //   that.delImg(this.oldImg);
                  // }
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      this.ruleForm.type = val.type;

      this.getRole(val.park_id);

      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);

      this.oldImg = val.picture;
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.ruleForm.type = val.type;
      this.getRole(val.park_id);
      // this.ruleForm = val
      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);
      // this.getInfo(val.id);

      this.drawer = true;
    },
    getInfo(id) {
      var that = this;
      this.fileList = [];
      userInfo({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.id,
          username: res.data.username,
          park_id: res.data.park_id,
          phone: res.data.phone,
          status: res.data.status,
          system_role_id: that.globalfunc.getParentsById(
            that.roleList,
            res.data.system_role_id
          ),
          type: res.data.type,
          company_id: res.data.company_id,
          picture: res.data.picture,
        };
        if (res.data.picture) {
          this.fileList.push({ url: this.imageOss + res.data.picture });
        }
        this.oldImg = res.data.picture;
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          delUser({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ruleForm.system_role_id = this.roleList[0].id
        
          console.log(that.ruleForm)
          this.$confirm("确认提交？")
            .then(() => {
              addUser(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加用户";
      this.cztype = "add";
      this.ruleForm = {
        username: "",
        password: "",
        repassword: "",
        park_id: this.$store.state.mainParkId,
        phone: "",
        status: 1,
        system_role_id: "",
        type: 2,
        company_id: "",
        picture: "",
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.ruleForm.park_id = this.userInfo.park_id;
      // }else{
      //   this.ruleForm.park_id =1
      // }
      // if (this.userInfo.type == 0) {
      //   this.ruleForm.type = 1;
      // } else if (this.userInfo.type == 1) {
      //   this.ruleForm.type = 2;
      // } else if (this.userInfo.type == 2) {
      //   this.ruleForm.type = 2;
      // } else if (this.userInfo.type == 3) {
      //   this.ruleForm.type = 1;
      // }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取企业
    getCompany(id) {
      openCompany({ park_id: id, is_page: 2 }).then((response) => {
        this.companyList = response.data.lists;
      });
    },
    // 获取园区
    getpark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取角色
    getRole(id) {
      const data = {
        is_page: 2,
        role_type: 1,
        is_default:5
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists 
      });
    },
    delUser() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          delUser({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      userList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    display: inline-block;
  }
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
</style>
